
function setupFormInteractions() {
  const formContainer = document.querySelector( '.e-div--forms-common' );
  if ( !formContainer ) return;

  function handleInputEvent( e ) {
    const tag = e.target.tagName == 'INPUT' || e.target.tagName == 'TEXTAREA';
    if ( e.target.classList.contains( 'hs-input' ) && tag ) {
      e.target.closest( '.field' ).classList.add( 'active' );
    }
  }

  function handleFocusOutEvent( e ) {
    if ( e.target.classList.contains( 'hs-input' ) ) {
      if ( e.target.value == '' ) {
        e.target.closest( '.field' ).classList.remove( 'active' );
      } else {
        e.target.closest( '.field' ).classList.add( 'active' );
      }
    }
  }

  document.addEventListener( 'load', handleInputEvent );
  document.addEventListener( 'change', handleInputEvent );
  document.addEventListener( 'input', handleInputEvent );
  document.addEventListener( 'click', handleInputEvent );
  document.addEventListener( 'blur', handleInputEvent );
  document.addEventListener( 'focus', handleInputEvent );
  document.addEventListener( 'focusout', handleFocusOutEvent );
}
document.addEventListener( 'DOMContentLoaded', () => {
  setupFormInteractions();
} );
